import { cn } from "utils";
import { I18nUtil } from "@utils/i18n";
import Translations from "@translate/components/CoPilot/CopilotAgent/AgentTopTab";

const I18n = I18nUtil.createScoped(Translations);

interface AgentTopTabProps {
  tabs: {
    id: string;
    label: string;
    disabled: boolean;
  }[];
  activeTab: string;
  setActiveTab: (tab: string) => void;
  rightContent?: React.ReactNode;
  className?: string;
}
export const AgentTopTab = ({
  tabs,
  activeTab,
  setActiveTab,
  rightContent,
  className,
}: AgentTopTabProps) => {
  return (
    <div
      className={cn("flex justify-between items-center w-full", className)}
      data-tracking-scope="agent-top-tab"
    >
      <tab-indicator
        className="flex md:items-end items-center gap-3 overflow-x-auto no-scrollbar [--capsule-bg-color:background_white_overlay5] [--capsule-border-radius:8px] [--animation-duration:0.2s] relative"
        effect="capsule"
      >
        {tabs.map((item) => {
          if (item.disabled) {
            return (
              <div
                className="w-[220px]"
                key={item.id}
                data-tracking-scope={item.id}
              >
                <div className="relative h-10 md:flex hidden items-end w-fit">
                  <div className="absolute top-0 left-[calc(100%-12px)] whitespace-nowrap px-1 py-0.5 body_bold_xs text-content_brand_primary bg-background_brand_overlay20 rounded">
                    {I18n.t("coming soon")}
                  </div>
                  <div className="bg-background_white_overlay5 chips md:md_chips sm_chips text-content_quaternary md:body_medium_m body_medium_s cursor-not-allowed rounded-lg w-fit">
                    {item.label}
                  </div>
                </div>
              </div>
            );
          }
          return (
            <div
              data-openreplay-label={`CopilotAgent · AgentTopTab · div | ${item.label}`}
              key={item.id}
              role="tab-item"
              data-tracking-scope={item.id}
              data-actived={item.id === activeTab}
              className={cn(
                "chips md:md_chips sm_chips md:body_medium_m body_medium_s border border-transparent text-content_secondary bg-background_white_overlay5 cursor-pointer",
                item.id === activeTab
                  ? "bg-background_brand_overlay10 text-content_primary border-border_brand_transparent50"
                  : "hover:text-content_primary hover:bg-background_white_overlay10",
              )}
              onClick={() => {
                if (item.disabled) {
                  return;
                }
                setActiveTab?.(item.id);
              }}
            >
              {item.label}
            </div>
          );
        })}
      </tab-indicator>
      {rightContent && <div className="md:hidden block">{rightContent}</div>}
    </div>
  );
};
